/*
  This All action on api
  https://github.com/public-apis/public-apis
*/
import { CONSTS } from "../config/objectConst";
import { contactsPageSize } from "./contactsPageSize";
import { httpRequest } from "./httpRequest";

const createParams = (data) => {
  let { archived, filter, keywords, orderby, skip } = data;
  let archivedParam = "";
  const statuses = filter ? filter : "";
  let resultFilters = "";
  const take = CONSTS.PAGE_SIZE;
  if (!orderby) {
    orderby = orderby ? orderby : "created desc";
  }
  if (archived !== undefined) {
    archivedParam = `archived eq ${archived}`;
  }
  if (archivedParam || statuses) {
    resultFilters = `&$filter=${archivedParam}${
      statuses ? ` ${archivedParam ? "and" : ""} ${statuses}` : ""
    }`;
  }

  return `?${take ? "&$take=" + take : ""}${
    skip ? "&$skip=" + skip : ""
  }${resultFilters}${keywords ? "&$searchQuery=" + keywords : ""}${
    orderby ? "&$orderby=" + orderby : ""
  }`;
};

export const api = {
  acceptTeamInvitation: async (code) => {
    return await httpRequest({
      data: {
        code,
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "POST",

      url: `${CONSTS.API.URL}team/personas/accept-invitation`,
    });
  },
  buyMemberSubscriptionApi: async (id, plan, coupon) => {
    return await httpRequest({
      data: {
        coupon,
        plan_id: plan,
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "POST",

      url: `${CONSTS.API.URL}team/personas/${id}/subscription`,
    });
  },
  cancelSubscription: async () => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}subscription/cancel`,
    });
  },
  cancelTeamMemberSubscriptionApi: async (id) => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}team/personas/${id}/subscription/cancel`,
    });
  },

  cloneCampaignApi: async (id) => {
    const result = await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}campaigns/${id}/clone`,
    });
    return result;
  },
  completeCampaignApi: async (id) => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}campaigns/${id}/complete`,
    });
  },
  createLogEnjectService: async (data) => {
    try {
      return await httpRequest({
        data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
        method: "POST",
        url: `${CONSTS.API.URL}logs`,
      });
    } catch (e) {
      console.error(e);
    }
  },

  deleteTeamMember: async (id) => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "DELETE",
      url: `${CONSTS.API.URL}team/personas/${id}`,
    });
  },

  editMemberNickNameApi: async (data) => {
    const { id, name } = { ...data };
    return await httpRequest({
      data: {
        name,
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}team/personas/${id}/nickname`,
    });
  },
  exportCampaignsTeamApi: async (data) => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "GET",
      url: `${CONSTS.API.URL}team/campaigns/export${createParams(data)}`,
    });
  },
  exportContactsApi: async (data) => {
    let { filter, keywords, orderby } = { ...data };

    if (!orderby) {
      orderby = "imported desc";
    }
    let newKeywords = keywords;
    if (keywords && keywords.includes("\\*")) {
      newKeywords = keywords.replaceAll("\\*", "*");
    }
    const params = `?${filter ? "&$filter=" + filter : ""}${
      newKeywords ? "&$searchQuery=" + newKeywords : ""
    }${orderby ? "&$orderby=" + orderby : ""}`;
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "GET",
      url: `${CONSTS.API.URL}contacts/export${params}`,
    });
  },

  exportContactsApiExecutions: async (data) => {
    let { filter, keywords, orderby } = { ...data };

    if (!orderby) {
      orderby = "imported desc";
    }
    let newKeywords = keywords;
    if (keywords && keywords.includes("\\*")) {
      newKeywords = keywords.replaceAll("\\*", "*");
    }
    const params = `?${filter ? "&$filter=" + filter : ""}${
      newKeywords ? "&$searchQuery=" + newKeywords : ""
    }${orderby ? "&$orderby=" + orderby : ""}`;
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "GET",
      url: `${CONSTS.API.URL}executions/export${params}`,
    });
  },

  exportCsvExampleApi: async () => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "GET",
      url: `${CONSTS.API.URL}contacts/csv-example`,
    });
  },

  getCampaignExecutionsStatisticsApi: async (id) => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "GET",
      url: `${CONSTS.API.URL}campaigns/${id}/executions-statistics`,
    });
  },

  getCampaignsTeamApi: async (data) => {
    return await httpRequest({
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      method: "GET",
      url: `${CONSTS.API.URL}team/campaigns${createParams(data)}`,
    });
  },

  getContactsCountApi: async (data) => {
    const { filter, keywords } = { ...data };
    const params = `?${keywords ? "&$searchQuery=" + keywords : ""}${
      filter ? "&$filter=" + filter : ""
    }`;
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "GET",
      url: `${CONSTS.API.URL}contacts/count${params}`,
    });
  },

  getContactsExecutionsApi: async (data) => {
    const { filter, keywords, orderby, skip } = data;
    const take = contactsPageSize.get();
    let newKeywords = keywords;
    if (keywords && keywords.includes("\\*")) {
      newKeywords = keywords.replaceAll("\\*", "*");
    }
    const params = `?${take ? "&$take=" + take : ""}${
      skip ? "&$skip=" + skip : ""
    }${filter ? "&$filter=" + filter : ""}${
      newKeywords ? "&$searchQuery=" + newKeywords : ""
    }${orderby ? "&$orderby=" + orderby : ""}`;
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "GET",
      url: `${CONSTS.API.URL}executions/page${params}`,
    });
  },
  getContactsLocationApi: async (data) => {
    let { keywords, take } = { ...data };
    if (!take) {
      take = 10;
    }
    const params = `?${keywords ? "&$searchQuery=" + keywords : ""}${
      take ? "&$take=" + take : ""
    }`;
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "GET",
      url: `${CONSTS.API.URL}contacts/locations${params}`,
    });
  },

  getManagementUrl: async () => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "GET",
      url: `${CONSTS.API.URL}subscription/management-url`,
    });
  },

  getSubscription: async () => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "GET",
      url: `${CONSTS.API.URL}subscription`,
    });
  },

  // ! probably dead code
  getWorkingHours: async () => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "GET",
      url: `${CONSTS.API.URL}workspace/working-hours-in-minutes`,
    });
  },
  inviteTeamMember: async (email) => {
    return await httpRequest({
      data: {
        email,
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "POST",

      url: `${CONSTS.API.URL}team/personas/invite`,
    });
  },

  ordersSync: async (orderId, orderReference) => {
    return await httpRequest({
      data: {
        order_id: orderId,
        reference: orderReference,
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "POST",
      url: `${CONSTS.API.URL}orders/sync`,
    });
  },

  resendTeamInvitation: async (id) => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "POST",
      url: `${CONSTS.API.URL}team/personas/${id}/resend-invitation`,
    });
  },

  resumeSubscription: async () => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}subscription/resume`,
    });
  },
  resumeTeamMemberSubscriptionApi: async (id) => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}team/personas/${id}/subscription/resume`,
    });
  },
  setDailyLimits: async (limits) => {
    const data = {
      daily_linkedin_follow_limit: +limits.followPerDayLimit.value,
      daily_linkedin_invitations_limit: +limits.invitationPerDayLimit.value,
      daily_linkedin_messages_limit: +limits.messagesPerDayLimit.value,
      daily_linkedin_react_on_post_limit: +limits.likesPerDayLimit.value,
    };
    return await httpRequest({
      data,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}workspace/daily-limits`,
    });
  },

  setNewData: async (url, data) => {
    return await httpRequest({
      data,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}${url}`,
    });
  },

  stopCampaignApi: async (id) => {
    return await httpRequest({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}campaigns/${id}/stop`,
    });
  },

  updateRoleApi: async (id, role) => {
    return await httpRequest({
      data: {
        role,
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}team/personas/${id}`,
    });
  },

  upgradeMemberSubscriptionApi: async (id, plan, coupon) => {
    return await httpRequest({
      data: {
        coupon,
        plan_id: plan,
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "PUT",

      url: `${CONSTS.API.URL}team/personas/${id}/subscription`,
    });
  },
  upgradeSubscription: async (id) => {
    return await httpRequest({
      data: { plan_id: id },
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      method: "PUT",
      url: `${CONSTS.API.URL}subscription/upgrade`,
    });
  },
};
